import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SharenotificationService {
   public behaviorSubject = new BehaviorSubject<number>(0);
   public videocallcubypatient = new BehaviorSubject<any>('cut'); // initial value
  constructor() { 
 
  }
}
